import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import question from '@/components/question'
import detail from '@/components/detail'
import default_detail from '@/components/default_detail'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/question/:trace_id',
      name: 'question',
      component: question
    },
    {
      path: '/zhen/goods/solution/:detail_id',
      name: 'detail',
      component: detail
    },
    {
      path: '/zhen/goods/default_solution/:detail_id',
      name: 'default_detail',
      component: default_detail
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})
